module.exports = __webpack_public_path__ + "static/media/button_click.06a5cb0c.mp3";